import { Box, Button, FormLabel, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import InputDatePicker from "../../../components/InputDatePicker";

function DateStartToEnd({ onSearch = () => {}, onClear = () => {} }) {
    const [datePick, setDatePick] = useState({ start: null, end: null });
    useEffect(() => {
        if (datePick.start > datePick.end) {
            setDatePick({ ...datePick, end: datePick.start });
        }
        if (!datePick.start && datePick.end) {
            setDatePick({ start: datePick.end, end: datePick.end });
        }
    }, [datePick]);
    return (
        <Grid container spacing={3} className="align-items-end">
            <Grid item xs={12} md={5} lg={3} className="mb-3">
                <Box className="w-100">
                    <FormLabel className="text-dark mb-4">Date Start</FormLabel>
                    <InputDatePicker
                        label=""
                        className="my-0 t-form-group-custom"
                        value={datePick.start}
                        onChange={date => setDatePick({ ...datePick, start: date })}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={5} lg={3} className="mb-3">
                <Box className="w-100">
                    <FormLabel className="text-dark mb-4">Date End</FormLabel>
                    <InputDatePicker
                        label=""
                        className="my-0 t-form-group-custom"
                        value={datePick.end}
                        minDate={datePick.start || undefined}
                        onChange={date => setDatePick({ ...datePick, end: date })}
                        error={false}
                        helperText={null}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={2} lg={2} className="mb-3 ">
                <Button
                    className="btn t-btn-primary w-100"
                    onClick={() => {
                        onSearch({
                            startDate: datePick.start,
                            endDate: datePick.end,
                        });
                    }}>
                    Search
                </Button>
            </Grid>
            <Grid item xs={12} md={2} lg={2} className="mb-3 ">
                <Button
                    className="btn t-btn-primary w-100"
                    onClick={() => {
                        setDatePick({ start: null, end: null });
                        onClear();
                    }}>
                    Clear
                </Button>
            </Grid>
        </Grid>
    );
}

export default DateStartToEnd;
